import { type CompanyAnalysisResponse } from "@/api";
import { Utility } from "./utility";

export interface CompanyAnalysis extends CompanyAnalysisResponse {}

export class CompanyAnalysis extends Utility<CompanyAnalysis> {
  constructor(init?: Partial<CompanyAnalysisResponse>) {
    super();
    Object.assign(this, init);
  }
}
